import type { EnumValueType } from '../../EnumUtils'
import { EnumUtils } from '../../EnumUtils'

/**
 * 售后类型常量
 */
export const AfterSalesTypeConstants = {
  RETURN_REFUND: {
    value: 1,
    label: '退货退款',
  },
  REFUND: {
    value: 2,
    label: '退款',
  },
  EXCHANGE: {
    value: 3,
    label: '换货',
  },
} as const

/**
 * 收货退货方式
 */
export const AfterSalesReturnTypeConstants = {
  PLATFORM_PICKUP: {
    value: 1,
    label: '平台安排上门取件',
  },
  ORDER_AGAIN: {
    value: 2,
    label: '再下一单',
  },
} as const

/**
 * 是否需要支付上门取件费
 */
export const NeedPickupFeeConstants = {
  NEED_PAY: {
    value: 1,
    label: '是',
  },
  FREE: {
    value: 0,
    label: '否',
  },
}

export type AfterSalesTypeValue = EnumValueType<typeof AfterSalesTypeConstants>

export const afterSalesTypeEnumUtils = new EnumUtils<AfterSalesTypeValue>(AfterSalesTypeConstants)

export type AfterSalesReturnTypeValue = EnumValueType<typeof AfterSalesReturnTypeConstants>

export const afterSalesReturnTypeEnumUtils = new EnumUtils<AfterSalesReturnTypeValue>(AfterSalesReturnTypeConstants)

export type NeedPickupFeeValue = EnumValueType<typeof NeedPickupFeeConstants>

export const needPickupFeeEnumUtils = new EnumUtils<NeedPickupFeeValue>(NeedPickupFeeConstants)

export default afterSalesTypeEnumUtils
